import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["comments", "loaded", "user", "onLoad", "onAdd"];
import React from "react";
import { UNLOADED, LOADING, LOADED } from "./Context";
import Comment from "./Comment";

/**
 * A list of comments
 * @param {{
 *  comments: object[],
 *  loaded: UNLOADED|SCHEDULED|LOADING|LOADED|undefined,
 *  user: {loggedIn: boolean, isAdmin: boolean, id: number}
 *  onLoad: () => void,
 *  onAdd: (comment: object) => void
 * }}
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CommentList = function CommentList(_ref) {
  var _ref$comments = _ref.comments,
    comments = _ref$comments === void 0 ? [] : _ref$comments,
    _ref$loaded = _ref.loaded,
    loaded = _ref$loaded === void 0 ? LOADED : _ref$loaded,
    user = _ref.user,
    onLoad = _ref.onLoad,
    onAdd = _ref.onAdd,
    callbacks = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: "comments comments-list list-group",
    children: [onAdd && /*#__PURE__*/_jsx(Comment, _objectSpread(_objectSpread({
      className: "list-group-item"
    }, callbacks), {}, {
      onEdit: onAdd
    })), comments.map(function (comment) {
      return /*#__PURE__*/_jsx(Comment, _objectSpread({
        className: "list-group-item",
        comment: comment,
        user: user
      }, callbacks), comment.cid || comment.id);
    }), loaded === UNLOADED && onLoad && /*#__PURE__*/_jsx("div", {
      className: "list-group-item load",
      children: /*#__PURE__*/_jsxs("a", {
        onClick: onLoad,
        children: [comments.length ? "Alle" : "", " Kommentare anzeigen"]
      })
    }, "load") || loaded === LOADING && /*#__PURE__*/_jsx("div", {
      className: "list-group-item loading",
      children: "Wird geladen..."
    }, "loading") || onAdd && comments.length >= 3 && /*#__PURE__*/_jsx(Comment, _objectSpread(_objectSpread({
      className: "list-group-item"
    }, callbacks), {}, {
      onEdit: onAdd
    }))]
  });
};
export default CommentList;
//# sourceMappingURL=List.js.map